import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { ShieldWarning, Check } from "@phosphor-icons/react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function DisclaimerModal() {
    const { user, setUser } = useAuth();
    const [open, setOpen] = useState(false);
    const [ack1, setAck1] = useState(false);
    const [ack2, setAck2] = useState(false);
    const [ack3, setAck3] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (user && !user.disclaimer_accepted_at) setOpen(true);
    }, [user]);

    const accept = async () => {
        setSaving(true);
        try {
            const { data } = await api.patch("/auth/disclaimer");
            setUser(data);
            setOpen(false);
        } finally { setSaving(false); }
    };

    if (!user) return null;
    const ready = ack1 && ack2 && ack3;

    return (
        <Dialog open={open} onOpenChange={() => {}}>
            <DialogContent className="sm:max-w-2xl [&>button]:hidden" data-testid="disclaimer-modal" onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()}>
                <DialogHeader>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                            <ShieldWarning size={20} weight="duotone" className="text-amber-700" />
                        </div>
                        <DialogTitle className="font-serif text-3xl">Before you begin</DialogTitle>
                    </div>
                </DialogHeader>

                <div className="space-y-5">
                    <p className="text-slate-700 leading-relaxed">
                        LienLift Direct is a <span className="font-semibold">judgment information &amp; document service</span>.
                        We are <span className="font-semibold">not a law firm</span> and we do not represent you.
                        Please confirm you understand how this service works:
                    </p>

                    <div className="space-y-3">
                        <label className="flex items-start gap-3 p-4 border border-slate-200 rounded-md cursor-pointer hover:bg-slate-50" data-testid="ack-1">
                            <Checkbox checked={ack1} onCheckedChange={setAck1} className="mt-0.5" />
                            <span className="text-sm text-slate-700">
                                I understand that LienLift Direct provides <strong>information, calculations, research and draft documents</strong> only — never legal advice.
                            </span>
                        </label>
                        <label className="flex items-start gap-3 p-4 border border-slate-200 rounded-md cursor-pointer hover:bg-slate-50" data-testid="ack-2">
                            <Checkbox checked={ack2} onCheckedChange={setAck2} className="mt-0.5" />
                            <span className="text-sm text-slate-700">
                                I understand that <strong>I will personally make the calls, send the offers, negotiate directly, and sign all agreements</strong>. LienLift Direct does not communicate with creditors on my behalf.
                            </span>
                        </label>
                        <label className="flex items-start gap-3 p-4 border border-slate-200 rounded-md cursor-pointer hover:bg-slate-50" data-testid="ack-3">
                            <Checkbox checked={ack3} onCheckedChange={setAck3} className="mt-0.5" />
                            <span className="text-sm text-slate-700">
                                I understand that for legal questions or representation I should <strong>consult a licensed attorney</strong> in my state.
                            </span>
                        </label>
                    </div>

                    <Button
                        onClick={accept}
                        disabled={!ready || saving}
                        data-testid="disclaimer-accept-btn"
                        className="w-full h-11 bg-[#0F1E3D] hover:bg-[#1A2C57]"
                    >
                        <Check size={16} className="mr-1.5" weight="bold" />
                        {saving ? "Saving…" : "I understand — let's get started"}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
